<template>
  <div class="indexPage custom_style" :class="show ? 'fixedStyle' : ''">
    <div class="head flex-rowl">
      <i class="iconfont icon-gongnenglan-kehuguanli"></i>
      <div class="content">
        <h1>分配客户资源</h1>
        <p>分配客户资源给销售专员</p>
      </div>
    </div>
    <div class="container_wrap">
      <div class="block">
        <div class="item flex-rowl">
          <p class="label">客户名称：</p>
          <p>
            {{
              customerDetail.info_truename
                ? customerDetail.info_truename
                : customerDetail.ext_name
            }}
          </p>
        </div>
        <div class="item flex-rowl">
          <p class="label">企业名称：</p>
          <p>{{ customerDetail.other_companystr }}</p>
        </div>
        <div class="item flex-rowl">
          <p class="label">职务：</p>
          <p>{{ customerDetail.other_job }}</p>
        </div>
        <div class="item flex-rowl">
          <p class="label">联系方式：</p>
          <p>{{ customerDetail.info_mobile }}</p>
        </div>
      </div>
      <div class="block">
        <div class="tit flex-rowl">
          <i class="iconfont icon-allot-o"></i> 分配给
        </div>
        <div class="column flex-rowc" @click="handleShow(1)">
          <i class="iconfont icon-yuangongguanli"></i> 选择员工
        </div>
        <div class="column two" v-if="selectQy.id">
          <div class="item flex-rowl">
            <p class="label">员工姓名：</p>
            <p>{{ selectQy.user.truename }}</p>
          </div>
          <!-- <div class="item flex-rowl">
            <p class="label">账号：</p>
            <p>{{ selectQy.accountid }}</p>
          </div> -->
          <div class="depart_box flex-rowl">
            <p>部门：</p>
            <div class="depart_wrap">
              <div class="depart flex-between">
                {{ selectQy.deptname }}
                <i class="iconfont icon-wenjianjia_o"></i>
              </div>
              <div class="depart flex-between">
                {{ selectQy.rolename }}
                <i class="iconfont icon-wenjianjia_o"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="input flex-between" @click="handleShow(2)">
          <van-field v-model="gettypestr" readonly placeholder="分配类型" />
          <i class="iconfont icon-bottom"></i>
        </div>
      </div>
      <div class="block">
        <div class="remark">
          <h1>备注：</h1>
          <div class="textarea">
            <van-field v-model="formData.details" type="textarea" />
          </div>
        </div>
      </div>
      <div class="custom_btn" @click="query">保存</div>
    </div>
    <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>
    <!-- 弹窗 -->
    <van-overlay :show="show">
      <div class="popup-wrap">
        <i class="iconfont icon-jujueweituo" @click="handleCancel"></i>
        <div class="popup-main">
          <div class="search_wrap flex-between">
            <div class="search_box flex-rowl">
              <i class="iconfont icon-search"></i>
              <div class="input">
                <van-field
                  v-model="customerParams.keyword"
                  placeholder="输入员工姓名/ID/部门，查找后选择员工"
                />
              </div>
            </div>
            <div class="btn" @click="getApplyCompanyList">查找显示</div>
          </div>
          <div class="scroll_wrap">
            <template v-if="qyList.length > 0">
              <div
                class="list flex-rowl"
                v-for="(item, index) in qyList"
                :key="index"
                @click="handleRadio(item.id)"
              >
                <div class="radio" :class="{ active: selectQyId === item.id }">
                  <i class="iconfont icon-gouxuan"></i>
                </div>
                <div class="content">
                  <div class="cont_item flex-rowl">
                    <p class="label">员工姓名：</p>
                    <p>{{ item.user.truename }}</p>
                  </div>
                  <!-- <div class="cont_item flex-rowl">
                  <p class="label">账号：</p>
                  <p>{{ item.accountid }}</p>
                </div> -->
                  <div class="depart_box flex-rowl">
                    <p>部门：</p>
                    <div class="depart flex-between">
                      {{ item.deptname }}
                      <i class="iconfont icon-wenjianjia_o"></i>
                    </div>
                  </div>
                  <div class="depart_box rolename_box flex-rowl">
                    <p>角色：</p>
                    <div class="depart flex-between">
                      {{ item.rolename }}
                      <i class="iconfont icon-wenjianjia_o"></i>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <van-empty description="暂无成员" v-else />
          </div>
        </div>
        <div class="popup-bottom flex-rowc">
          <div class="custom_btn next" @click="handleQueryQy">
            确认<span><i class="iconfont icon-selected"></i></span>
          </div>
        </div>
      </div>
    </van-overlay>

    <!-- 弹窗 start -->
    <van-popup
      v-model="isShowPopup"
      position="bottom"
      :lock-scroll="true"
      :style="{ height: '40%' }"
    >
      <div>
        <van-picker
          show-toolbar
          :columns="columnOne"
          @confirm="onConfirm"
          value-key="evalue"
          @cancel="isShowPopup = false"
        />
      </div>
    </van-popup>
    <!-- 弹窗 end -->
  </div>
</template>
<script>
import {
  getQywxset,
  getCustomerDetail,
  addCustomerDis,
  editCustomerDis,
  getCustomerDisDetail,
  encryptstringview,
} from "../../../api/api";
import { getApplyCompanyList } from "../../../api/company";
import { mapState } from "vuex";
export default {
  name: "rAllocationCustomer",
  data() {
    return {
      qyid: "",
      id: "",
      idc: "",
      loading: false,
      formData: {
        openid: this.$store.state.OPENID,
        cmuseropenid: "",
        customerid: "",
        // createdate: "",
        getstate: "",
        gettype: "",
        result: 1,
        details: "",
        others: "",
      },
      gettypestr: "", // 分配类型
      customerDetail: "", // 客户详情

      // 企业成员
      qyList: [],
      selectQyId: "",
      selectQy: {}, // 选择的企业

      keyword: " ",
      remark: "",
      type: "",
      show: false,
      customerActive: "",

      columnOne: [],
      isShowPopup: false,

      customerParams: {
        qyid: "",
        keyword: "",
        checkstate: 1, // 0审核中 1已通过 2拒绝加入 3已退出 4已被移出
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.customerParams.qyid = USERINFO.qy.id ? USERINFO.qy.id : "";
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, idC } = JSON.parse(res.jsondata);
        this.id = id;
        this.idc = idC;
        this.formData.customerid = id;

        this.getCustomerDetail();
        if (this.idc != 0) {
          this.getCustomerDisDetail();
        }
        this.getQywxset("customershare");
      } else {
        this.$router.back();
      }
    },

    // 获取触达详情
    getCustomerDisDetail() {
      getCustomerDisDetail({ id: this.idc }).then((res) => {
        this.formData.customerid = res.customerid;
        this.formData.id = res.id;
        this.formData.getstate = res.getstate;
        this.getstatestr = res.getstatestr;
        this.formData.gettype = res.gettype;
        this.gettypestr = res.gettypestr;
        this.formData.result = res.result;
        this.resultstr = res.resultstr;
        this.formData.details = res.details;
        this.formData.others = res.others;
        this.formData.cmuseropenid = res.cmuseropenid;

        this.getApplyCompanyList(res.cmuseropenid);
      });
    },
    // 获取客户详情
    getCustomerDetail() {
      getCustomerDetail({ id: this.id }).then((res) => {
        this.customerDetail = res;
      });
    },
    // 获取企业成员
    getApplyCompanyList(cmuseropenid) {
      getApplyCompanyList(this.customerParams).then((res) => {
        this.qyList = res;
        // this.qyList = res.filter((v) => v.rolename != "创建人");
        if (cmuseropenid != "" && cmuseropenid) {
          res.forEach((v) => {
            if (v.openid == cmuseropenid) {
              this.selectQy = v;
            }
          });
        }
      });
    },
    getQywxset() {
      let { idc, customerDetail } = this;
      console.log(idc, customerDetail, "==-===");
      getQywxset("customershare").then((res) => {
        if (idc != "") {
          if (customerDetail.gettype) {
            this.columnOne = res.filter((v) => v.evalue != "首次分配");
          } else {
            this.columnOne = res;
          }
        } else {
          if (customerDetail.gettype) {
            this.columnOne = res.filter((v) => v.evalue != "首次分配");
          } else {
            this.columnOne = res;
          }
        }
      });
    },
    onConfirm(e) {
      this.formData.gettype = e.id;
      this.gettypestr = e.evalue;
      this.isShowPopup = false;
    },

    // 员工选择
    handleRadio(id) {
      this.selectQyId = id;
    },
    // 选中员工
    handleQueryQy() {
      let { selectQyId, qyList } = this;
      if (selectQyId == "") {
        this.$toast("请选择员工");
      } else {
        qyList.forEach((v) => {
          if (v.id == selectQyId) {
            this.selectQy = v;
            this.formData.cmuseropenid = v.openid;
          }
        });
        this.handleCancel();
      }
    },
    // 关系选择员工弹窗
    handleCancel() {
      this.show = false;
    },

    handleShow(type) {
      if (type == 1) {
        this.show = true;
        this.getApplyCompanyList();
      } else {
        this.isShowPopup = true;
        this.getQywxset();
      }
    },

    query() {
      let { formData, idc } = this;
      if (formData.cmuseropenid == "") {
        this.$toast("请选择分配人员");
        return;
      }
      if (formData.gettype == "") {
        this.$toast("请选择分配类型");
        return;
      }
      if (idc == 0) {
        this.addCustomerDis();
      } else {
        this.editCustomerDis();
      }
    },

    // 修改
    editCustomerDis() {
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editCustomerDis(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(res.message);
          }, 500);
          setTimeout(() => {
            history.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 新增
    addCustomerDis() {
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      addCustomerDis(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(res.message);
          }, 500);
          setTimeout(() => {
            history.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  box-sizing: border-box;
  &.fixedStyle {
    overflow: hidden;
    height: 100vh;
  }
  .head {
    .icon-gongnenglan-kehuguanli {
      font-size: 44px;
    }
  }
  /deep/ .van-cell {
    background: none;
    height: 100%;
    padding: 0;
  }
  .container_wrap {
    padding: 70px 83px;
    box-sizing: border-box;
    font-size: 22px;
    color: #3c3c3c;
    .block {
      margin-bottom: 80px;
      .item {
        margin-bottom: 18px;
        .label {
          width: 140px;
          flex-shrink: 0;
        }
      }
      .tit {
        font-size: 24px;
        color: #333333;
        margin-bottom: 20px;
        .iconfont {
          font-size: 34px;
          margin-right: 10px;
        }
      }
      .column {
        border: 1px solid #aaaaaa;
        font-size: 28px;
        color: #333333;
        margin-bottom: 39px;
        height: 110px;
        .icon-yuangongguanli {
          font-size: 44px;
          margin-right: 20px;
        }
        &.two {
          height: auto;
          margin-bottom: 0;
          padding: 44px 0 44px 30px;
          font-size: 22px;
        }
      }
      .remark {
        h1 {
          font-size: 22px;
          color: #aaaaaa;
          margin-bottom: 20px;
        }
        .textarea {
          padding: 20px;
          box-sizing: border-box;
          background: #fafafa;
          height: 300px;
          width: 100%;
        }
      }
      .input {
        border-bottom: 1px dashed #c3c3c3;
        padding: 26px 14px;
        box-sizing: border-box;
      }
    }
    .custom_btn {
      width: 280px;
      height: 50px;
      line-height: 50px;
    }
  }
  .depart_box {
    // margin-top: 20px;
    align-items: flex-start;
    .depart {
      border: 1px solid #aaaaaa;
      font-size: 18px;
      width: 190px;
      height: 40px;
      padding: 0 20px;
      box-sizing: border-box;
      margin-left: 30px;
      border-radius: 20px;
    }
    &.rolename_box {
      margin-top: 15px;
    }
  }
  .depart_wrap {
    .depart {
      margin-bottom: 10px;
    }
  }
  .popup-wrap {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    height: 75%;
    font-size: 22px;
    color: #3c3c3c;
    .icon-jujueweituo {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -90px;
      color: #fff;
      font-size: 50px;
    }
    .popup-main {
      .search_wrap {
        width: 660px;
        border-bottom: 1px solid #dddddd;
        margin: 56px auto 49px;
        padding-bottom: 29px;
        box-sizing: border-box;

        .search_box {
          color: #c8c8c8;
          flex: 1;
          .input {
            flex: 1;
            padding: 0 16px;
          }
          .iconfont {
            font-size: 36px;
            color: #565757;
          }
        }
        .btn {
          width: 130px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          background: #1e1e1e;
          font-size: 18px;
          color: #fff;
        }
      }
      .scroll_wrap {
        height: 50vh;
        overflow-y: scroll;
        .list {
          width: 600px;
          border: 1px solid #dcdcdc;
          padding: 44px 30px;
          box-sizing: border-box;
          margin: 0 auto 30px;
          .radio {
            margin-right: 28px;
            color: #dadada;
            .iconfont {
              font-size: 40px;
            }
            &.active {
              color: #333333;
            }
          }
          .cont_item {
            margin-bottom: 25px;

            .label {
              width: 140px;
            }
          }
        }
      }
    }
    .popup-bottom {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 200px;
      box-shadow: 0 -1px 8px 2px rgba(0, 0, 0, 0.05);
      .custom_btn {
        width: 500px;
        height: 60px;
        line-height: 60px;
        border-radius: 0;
        margin: 0 auto 60px;
      }
    }
  }
}
</style>